import {Component, forwardRef} from "@angular/core";
import {FUIAbstractPill} from "../../framework/abstract-pill";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUILocalisationPillComponent),
            multi: true
        }
    ],
    selector: "fui-localisation-pill",
    templateUrl: "./localisation-pill.component.html"
})
export class FUILocalisationPillComponent extends FUIAbstractPill {
}
